import type { SaveStorage } from './SaveStorage';
import type { SaveBlob } from '@core/save/schema';
import { blobToJson, jsonToBlob } from '@core/save/codec';

const KEY = 'bme.save.v1';

/**
 * Web implementation backed by localStorage. localStorage is not durable
 * (TECHNICAL_APPROACH §2 — Safari ITP eviction), which is why the export code is
 * the real backup; this is just the convenience autosave slot.
 */
export class WebSaveStorage implements SaveStorage {
  async load(): Promise<SaveBlob | null> {
    try {
      const json = localStorage.getItem(KEY);
      if (!json) return null;
      return jsonToBlob(json);
    } catch {
      // Corrupt or unreadable slot — treat as no save rather than crashing boot.
      return null;
    }
  }

  async save(blob: SaveBlob): Promise<void> {
    localStorage.setItem(KEY, blobToJson(blob));
  }

  async clear(): Promise<void> {
    localStorage.removeItem(KEY);
  }
}
